import React, { useState, useEffect } from "react";

import './../styles/Application.scss'
import closesvg from '../img/closesvg.svg'
import Api from "../common/api";

const Application = () => {

  const [isActive, isSetActive] = useState(false)

  const [datas, setData] = useState([])

  React.useEffect(() => {
    Api.get("/careers/list/").then((res) => {
      setData(res.data.items)
      // setCurrentTab(res.data.items[res.data.items.findIndex(x => x.Link == activePath)])
    });
  }, []);


  const subWord = (string, wordCount = 21) => {
    return string.split(" ").slice(0, wordCount).join(" ")
  }

  return (
    <>
      {datas.length > 0 ? (
        <h3
          style={{ marginLeft: "-20px" }}
          className="header-three container-sm"
        >
          Açık Pozisyonlar
        </h3>
      ) : null}
      {
        datas
          ? datas.map((data) => (

            <div className="application-list">
              <div className="application-card">
                <h3>{data.Title}</h3>
                <p dangerouslySetInnerHTML={{ __html: subWord(data.Content) }}>
                </p>
                <button className="get-detail-btn" onClick={() => isSetActive(data.id)}>Detaylar için tıklayınız</button>
                <div className={isActive == data.id ? "full-modal-box-two active" : "full-modal-box-two"}>
                  <div className="modal-box-container-two">
                    <button onClick={() => isSetActive("")} className="close-svg-btn-two">
                      <img src={closesvg} alt="close" />
                    </button>
                    <div className="title-header">
                      <h5>{data.Title}</h5>
                    </div>
                    <p dangerouslySetInnerHTML={{ __html: data.Content }}></p>
                  </div>
                </div>
              </div>
            </div>
          )) : null
      }
    </>
  )
}

export default Application
